import React from "react";

const Plus = ({ ...rest }) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="plus">
                <path
                    id="Icon"
                    d="M8.75 4.08334V8.75001M8.75 8.75001V13.4167M8.75 8.75001H4.08333M8.75 8.75001H13.4167"
                    stroke="#0F1016"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Plus;
